export default {
      id: "phone-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "sprite.svg#phone",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./static/images/sprite-icons/phone.svg
// module id = FRIT
// module chunks = 1